// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_headerContainer__LApN\\+ {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: var(--app-header-height, 60px);
  box-sizing: border-box;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-bottom: 1px solid rgba(15, 23, 42, 0.1);
  box-shadow:
    0 1px 3px rgba(15, 23, 42, 0.05),
    0 8px 20px rgba(15, 23, 42, 0.07);
}

.header_headerRow__Ri25B {
  position: relative;
  z-index: 1;
  flex: 1 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  gap: 0.75rem;
  min-height: var(--app-header-height, 60px);
}

.header_headerLeft__U7apz {
  display: flex;
  align-items: center;
  min-width: 0;
}

.header_headerRight__jPsz3 {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.header_brandLogo__cxktV {
  display: block;
  max-height: clamp(28px, 4.5vh, 40px);
  width: auto;
  max-width: min(300px, 36vw);
  object-fit: contain;
  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.15));
}

.header_sidebarToggle__59Tj3 {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 2.125rem;
  height: 2.125rem;
  margin-left: 0.75rem;
  padding: 0;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.42);
  background: rgba(255, 255, 255, 0.12);
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    transform 0.1s ease;
}

.header_sidebarToggle__59Tj3:hover {
  background: rgba(255, 255, 255, 0.22);
  border-color: rgba(255, 255, 255, 0.55);
}

.header_sidebarToggle__59Tj3:active {
  transform: scale(0.96);
}

.header_sidebarToggle__59Tj3:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
}

.header_toggleBar__ieqDB {
  width: 14px;
  height: 2px;
  border-radius: 1px;
  background-color: rgba(255, 255, 255, 0.95);
}

.header_userBlock__D3nWL {
  text-align: right;
  margin-right: 0.5rem;
  min-width: 0;
}

.header_userName__7bMav {
  font-size: 0.9375rem;
  font-weight: 600;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.98);
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: min(42vw, 340px);
}

.header_userEmail__JKf6w {
  font-size: 0.8125rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.84);
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: min(44vw, 360px);
}

.header_avatarBtn__wAijO {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.38);
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.2);
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.1s ease;
}

.header_avatarBtn__wAijO:hover {
  border-color: rgba(255, 255, 255, 0.55);
}

.header_avatarBtn__wAijO:focus,
.header_avatarBtn__wAijO:focus-visible {
  outline: none;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.2);
}

.header_avatarBtn__wAijO::-moz-focus-inner {
  border: 0;
}

.header_avatarImg__yHAEp {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.header_dropdown__xHMau {
  position: absolute;
  top: calc(100% + 4px);
  right: 1rem;
  z-index: 2;
  min-width: 11rem;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow:
    0 4px 6px -4px rgba(15, 23, 42, 0.08),
    0 10px 20px -5px rgba(15, 23, 42, 0.12);
  overflow: hidden;
  opacity: 1;
}

.header_hide__uJdke {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.header_dropdown__xHMau:not(.header_hide__uJdke) {
  animation: header_dropdownIn__gHXb6 0.16s ease;
}

@keyframes header_dropdownIn__gHXb6 {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.header_dropdownItem__uUjB0 {
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.7rem 1.1rem;
  font-size: 1.0625rem;
  font-weight: 500;
  font-family: inherit;
  color: #334155;
  cursor: pointer;
  text-decoration: none;
  border: none;
  background: #fff;
  transition: background-color 0.12s ease, color 0.12s ease;
}

.header_dropdownItem__uUjB0:hover {
  background-color: #f8fafc;
  color: #0f172a;
}

.header_dropdownItem__uUjB0:focus-visible {
  outline: none;
  background-color: #f1f5f9;
}

.header_dropdownDivider__fNvQW {
  height: 1px;
  background: #f1f5f9;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/providers/components/header/header.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,0CAA0C;EAC1C,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,8CAA8C;EAC9C;;qCAEmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,eAAe;EACf;;;uBAGqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,oCAAoC;EACpC,2CAA2C;EAC3C,eAAe;EACf;;;uBAGqB;AACvB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB;;2CAEyC;EACzC,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,8CAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".headerContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  min-height: var(--app-header-height, 60px);\n  box-sizing: border-box;\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.1);\n  box-shadow:\n    0 1px 3px rgba(15, 23, 42, 0.05),\n    0 8px 20px rgba(15, 23, 42, 0.07);\n}\n\n.headerRow {\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 1rem;\n  gap: 0.75rem;\n  min-height: var(--app-header-height, 60px);\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n}\n\n.headerRight {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.brandLogo {\n  display: block;\n  max-height: clamp(28px, 4.5vh, 40px);\n  width: auto;\n  max-width: min(300px, 36vw);\n  object-fit: contain;\n  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.15));\n}\n\n.sidebarToggle {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  width: 2.125rem;\n  height: 2.125rem;\n  margin-left: 0.75rem;\n  padding: 0;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.42);\n  background: rgba(255, 255, 255, 0.12);\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease,\n    transform 0.1s ease;\n}\n\n.sidebarToggle:hover {\n  background: rgba(255, 255, 255, 0.22);\n  border-color: rgba(255, 255, 255, 0.55);\n}\n\n.sidebarToggle:active {\n  transform: scale(0.96);\n}\n\n.sidebarToggle:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);\n}\n\n.toggleBar {\n  width: 14px;\n  height: 2px;\n  border-radius: 1px;\n  background-color: rgba(255, 255, 255, 0.95);\n}\n\n.userBlock {\n  text-align: right;\n  margin-right: 0.5rem;\n  min-width: 0;\n}\n\n.userName {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  letter-spacing: -0.015em;\n  color: rgba(255, 255, 255, 0.98);\n  line-height: 1.25;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: min(42vw, 340px);\n}\n\n.userEmail {\n  font-size: 0.8125rem;\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.84);\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: min(44vw, 360px);\n}\n\n.avatarBtn {\n  flex-shrink: 0;\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 2px solid rgba(255, 255, 255, 0.38);\n  background: rgba(255, 255, 255, 0.1);\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.2);\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease,\n    transform 0.1s ease;\n}\n\n.avatarBtn:hover {\n  border-color: rgba(255, 255, 255, 0.55);\n}\n\n.avatarBtn:focus,\n.avatarBtn:focus-visible {\n  outline: none;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.2);\n}\n\n.avatarBtn::-moz-focus-inner {\n  border: 0;\n}\n\n.avatarImg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 1rem;\n  z-index: 2;\n  min-width: 11rem;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow:\n    0 4px 6px -4px rgba(15, 23, 42, 0.08),\n    0 10px 20px -5px rgba(15, 23, 42, 0.12);\n  overflow: hidden;\n  opacity: 1;\n}\n\n.hide {\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.dropdown:not(.hide) {\n  animation: dropdownIn 0.16s ease;\n}\n\n@keyframes dropdownIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dropdownItem {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 0.7rem 1.1rem;\n  font-size: 1.0625rem;\n  font-weight: 500;\n  font-family: inherit;\n  color: #334155;\n  cursor: pointer;\n  text-decoration: none;\n  border: none;\n  background: #fff;\n  transition: background-color 0.12s ease, color 0.12s ease;\n}\n\n.dropdownItem:hover {\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\n.dropdownItem:focus-visible {\n  outline: none;\n  background-color: #f1f5f9;\n}\n\n.dropdownDivider {\n  height: 1px;\n  background: #f1f5f9;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `header_headerContainer__LApN+`,
	"headerRow": `header_headerRow__Ri25B`,
	"headerLeft": `header_headerLeft__U7apz`,
	"headerRight": `header_headerRight__jPsz3`,
	"brandLogo": `header_brandLogo__cxktV`,
	"sidebarToggle": `header_sidebarToggle__59Tj3`,
	"toggleBar": `header_toggleBar__ieqDB`,
	"userBlock": `header_userBlock__D3nWL`,
	"userName": `header_userName__7bMav`,
	"userEmail": `header_userEmail__JKf6w`,
	"avatarBtn": `header_avatarBtn__wAijO`,
	"avatarImg": `header_avatarImg__yHAEp`,
	"dropdown": `header_dropdown__xHMau`,
	"hide": `header_hide__uJdke`,
	"dropdownIn": `header_dropdownIn__gHXb6`,
	"dropdownItem": `header_dropdownItem__uUjB0`,
	"dropdownDivider": `header_dropdownDivider__fNvQW`
};
export default ___CSS_LOADER_EXPORT___;
